// libs
import React, { useContext, memo } from "react";
import { HalfCard as DLSHalfCard } from "@swiggy-private/dls-web-core/dist/components/HalfCard";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

// styled components
import { Container, Header, Content, TnCItem } from "./styled";

// hooks
import { useEffectOnce } from "@swiggy-private/core-ui";

// contexts
import { AnalyticsContext } from "@swiggy-private/checkout-core";

// helpers
import { impressionTnCHC } from "@payment-client/components/show-payments/components/review-bill-details-renderer/helpers/analytics";

interface HalfCardProps {
    isOpen: boolean;
    onClose: () => void;
    halfCardData: string[];
}

export const HalfCard: React.FC<HalfCardProps> = ({ isOpen, onClose, halfCardData }) => {
    const { impressionEvent } = useContext(AnalyticsContext);

    useEffectOnce(() => {
        impressionTnCHC(impressionEvent);
    });

    if (!halfCardData) {
        return null;
    }

    return (
        <DLSHalfCard
            isOpen={isOpen}
            onClose={onClose}
            hasCustomPadding
            closeOnOverlayClick
            hideCloseIcon={false}
            variant="v3"
        >
            <Container>
                <Header>
                    <Text variant="V2.body1.neutral.bold">Terms and Conditions</Text>
                </Header>

                <Content>
                    {halfCardData.map((tnc) => (
                        <TnCItem variant="V2.body3.neutral.regular" color="text_Med_Emphasis" key={tnc}>
                            {tnc}
                        </TnCItem>
                    ))}
                </Content>
            </Container>
        </DLSHalfCard>
    );
};

export default memo(HalfCard);
